<template>
  <div>
    <el-dialog
      :title="batchEditData.title"
      :visible.sync="batchEditData.show"
      center
      width="400px"
    >
      <el-form :model="formData" label-width="100px">
        <el-form-item :label="$t('Status')" v-if="batchEditData.type == 1">
          <el-select
            style="width: 100%"
            v-model="formData.State"
             :placeholder="$t('Status')"
            clearable
          >
            <el-option :label="$t('Enable')" :value="1"> </el-option>
            <el-option :label="$t('deactivate')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('AutomaticExchangeRate')" v-if="batchEditData.type == 2">
          <el-select
            style="width: 100%"
            v-model="formData.State"
            :placeholder="$t('AutomaticExchangeRate')"
            clearable
          >
            <el-option :label="$t('Enable')" :value="1"> </el-option>
            <el-option :label="$t('deactivate')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')">
          <el-input
            v-model="formData.GoogleCode"
           :placeholder="$t('GoogleVerificationCode')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">{{$t('Save')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    batchEditData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        State: "",
        GoogleCode: "",
        Type: "",
      },
    };
  },
  created() {
    this.formData.Type = this.batchEditData.type;
    // this.formData.PSymbol = this.editData.data.PSymbol;
    // this.formData.Symbol = this.editData.data.Symbol;
    // this.formData.RechargeRate = this.editData.data.RechargeRateEx;
    // this.formData.WithwardRate = this.editData.data.WithwardRateEx;
  },
  methods: {
    save() {
      this.$emit("saveBatchEditData", this.formData);
    },
  },
};
</script>

<style scoped></style>
